import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4ClaimsArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'How to File a Renters Insurance Claim | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn how to file a renters insurance claim step by step and what documents help speed up processing.'
      );
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/how-to-file-a-renters-insurance-claim"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>How to file a renters insurance claim</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>A simple process to report loss, document evidence, and move your claim forward faster.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4">
            <div className="card-body">
              <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
              <p>
                File as soon as possible, document everything, and respond quickly to adjuster requests. Clear records
                often make the process smoother.
              </p>
              <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>Claim steps</h3>
              <ol style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>Take photos/videos and make a loss inventory.</li>
                <li style={{ marginBottom: '0.5rem' }}>Report the claim through your carrier portal/phone line.</li>
                <li style={{ marginBottom: '0.5rem' }}>Submit requested documents and receipts.</li>
                <li style={{ marginBottom: '0.5rem' }}>Track claim status and follow up on pending items.</li>
                <li>Keep all communication records until claim closure.</li>
              </ol>
              <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                For theft or water events, review{' '}
                <Link to="/knowledge-base/does-ho4-cover-theft" style={articleLinkStyle}>
                  theft coverage
                </Link>{' '}
                and{' '}
                <Link to="/knowledge-base/does-ho4-cover-water-damage" style={articleLinkStyle}>
                  water-damage coverage
                </Link>{' '}
                to understand expectations.
              </p>
            </div>
          </article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Set up HO-4 coverage before loss happens.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help with claim prep?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can walk you through what details to gather before filing.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4ClaimsArticlePage;

